import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Toolbar,
  Sort,
  Resize,
  Edit,
} from "@syncfusion/ej2-react-grids";
import {
  AddApprovedPartsApi,
  GetApprovedPartById,
  GetPartById,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import TextInputField from "../../components/TextInputField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const ApprovedPart = () => {
  const navigate = useNavigate();
  let param = useParams();
  const part_id = param.p_id;
  const gridRef = useRef(null);
  const [Part, setPart] = useState("");
  const [Parts, setParts] = useState([]);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(true);
  const [loadBtn, setLoadBtn] = useState(false);

  const customersGrid = [
    {
      field: "mfg_pn",
      headerText: "Mfg PN",
      minWidth: "120",
      width: "260",
      maxWidth: "680",
      textAlign: "center",
    },
    {
      field: "mfg_name",
      headerText: "Mfg Name",
      minWidth: "120",
      width: "260",
      maxWidth: "680",
      textAlign: "left",
    },
  ];

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Part");
  };

  const actionBegin = (args) => {
    if (args.requestType === "save") {
      const found = Parts.some(
        (item, i) =>
          item.mfg_pn === args.data.mfg_pn &&
          args.data.mfg_pn !== args.previousData.mfg_pn,
      );
      if (found) {
        args.cancel = true;
        showErrorToast("Error!", "Mfg PN must be unique!");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    const AParts = gridRef.current.getCurrentViewRecords();
    const pn_list = AParts.filter((item) => item.mfg_pn).map(
      (item) => item.mfg_pn,
    );
    const name_list = AParts.filter((item) => item.mfg_pn).map(
      (item) => item.mfg_name,
    );

    try {
      const response = await AddApprovedPartsApi(part_id, pn_list, name_list);
      if (response.success) {
        showSuccessToast("Success!", "Approved Parts updated successfully!");
        navigate("/Part");
      } else
        showErrorToast(
          "Error!",
          "Approved Parts failed to update!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "Approved Parts did not update!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (part_id) {
        TimeoutUtility.resetTimeout();
        setloading(true);
        trackPromise(
          Promise.all([GetPartById(part_id), GetApprovedPartById(part_id)])
            .then(([result1, result2]) => {
              setPart(
                `${result1.data.part_number} - ${result1.data.description}`,
              );
              const AParts = result2.data.map((item) => ({
                mfg_name: item.mfg_name,
                mfg_pn: item.mfg_pn,
              }));
              setParts(AParts);
            })
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [part_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="APPROVED PARTS" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={8} className="container-col">
              {loading && promiseInProgress ? (
                <LoadingIndicator />
              ) : (
                <>
                  <TextInputField
                    label="Part Number & Description:"
                    name="location"
                    value={Part}
                    placeholder="Part Number & Description:"
                    disabled
                  />
                  <GridComponent
                    className="custom-grid mt-8"
                    dataSource={Parts}
                    ref={gridRef}
                    // height="calc(62vh - 60px)"
                    allowSorting
                    allowResizing
                    editSettings={{
                      allowEditing: true,
                      allowAdding: true,
                      allowDeleting: true,
                    }}
                    actionBegin={actionBegin}
                    toolbar={["Add", "Edit", "Delete", "Update", "Cancel"]}
                    rowHeight={48}
                  >
                    <ColumnsDirective>
                      {customersGrid.map((item, index) => (
                        <ColumnDirective
                          key={index}
                          {...item}
                          validationRules={{ required: true }}
                        />
                      ))}
                    </ColumnsDirective>
                    <Inject services={[Resize, Edit, Toolbar, Sort]} />
                  </GridComponent>
                </>
              )}
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Update"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ApprovedPart;
